import React, { Component }  from 'react';
import { connect } from 'react-redux';
import './Quote.css';

class Quote extends Component {

	render() {
		const style = { 
			color: this.props.color
		}

		const {quote, author} = this.props.quoteInfo;

		return (
			<div className="quote" style={ style }>
				<i className="fas fa-quote-left" ></i>
				<h1 className="quote-text" >{quote}</h1>
				<h2 className="quote-author">- {author}</h2>
			</div>
		);	
	}
}

const mapStateToProps = state => ({
	quoteInfo: state.settings.quoteInfo,
	color: state.settings.color
});

export default connect(mapStateToProps, null)(Quote);
